import type { BotStrategyConfiguration } from 'api/elplan/elplan.types'
import type { TableCellAdapter } from 'ui/components/HourlyDataTable/HourlyDataTable.types'

type SeriesArray = BotStrategyConfiguration['series']

/** Build the opaque cell key for a strategy table cell */
export function makeStrategyCellKey(hourIndex: number, seriesId: string): string {
  return `${hourIndex}-${seriesId}`
}

export function parseStrategyCellKey(cellKey: string): { hourIndex: number; seriesId: string } | null {
  const firstDashIndex = cellKey.indexOf('-')
  if (firstDashIndex === -1) {
    return null
  }
  const hourIndex = parseInt(cellKey.slice(0, firstDashIndex), 10)
  if (!Number.isFinite(hourIndex)) {
    return null
  }
  return { hourIndex, seriesId: cellKey.slice(firstDashIndex + 1) }
}

export function makeStrategyTableAdapter(series: SeriesArray, rowCount: number): TableCellAdapter {
  return {
    columnCount: series.length,
    rowCount,
    getCoordinate(cellKey) {
      const parsed = parseStrategyCellKey(cellKey)
      if (parsed === null || parsed.hourIndex >= rowCount) {
        return null
      }
      const { hourIndex, seriesId } = parsed
      const columnIndex = series.findIndex((s) => s.id === seriesId)
      return columnIndex === -1 ? null : { rowIndex: hourIndex, columnIndex }
    },
    getCellKey({ rowIndex: hourIndex, columnIndex }) {
      const s = series[columnIndex]
      return s ? makeStrategyCellKey(hourIndex, s.id) : null
    },
  }
}
